import { AutogenModelCustomTransControl, AutogenRowCustomTransControl } from "./autogen/AutogenModelCustomTransControl";

export class ModelCustomTransControl extends AutogenModelCustomTransControl<RowCustomTransControl> {
	constructor() {
		super(RowCustomTransControl);
	}
}

export class RowCustomTransControl extends AutogenRowCustomTransControl {
}